/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import NewVideoStory from "./new";
import OldVideoStory from "./old";
import PropTypes from "prop-types";
import get from "lodash/get";
import { useSelector } from "react-redux";
import StoryRowWrapper from "../story-row-wrapper.js";

const VideoStory = props => {
  const { config, storyStoreField, storyPageType } = props;
  const isPbEnabled = get(config, ["pagebuilder-config", "featureToggle", "videoStoryPage"], false);
  if (isPbEnabled) {
    const storyRows = useSelector(state =>
      get(state, ["qt", "config", "pagebuilder-config", storyStoreField, storyPageType, "rows"], [])
    );
    return (
      <StoryRowWrapper rows={storyRows}>
        <NewVideoStory {...props} />
      </StoryRowWrapper>
    );
  }
  return <OldVideoStory {...props} />;
};

VideoStory.propTypes = {
  config: PropTypes.object,
  storyStoreField: PropTypes.string,
  storyPageType: PropTypes.string
};

VideoStory.defaultProps = {
  storyStoreField: "story",
  storyPageType: "video-story"
};
export default VideoStory;
